import type { Node } from 'reactflow';

/** TH-3b — one traversal → the exchange cluster. Camera frames nodeIds; the dim +
 * ring key off turnKeys. Canonical turn nodes share data.turnKey === userMessageId
 * (chatDagDataProcessor). Keep this PURE + node-array-only (unit-testable). */
export function resolveExchangeCluster(
  nodes: Node[], anchorTurnKey: string,
): { nodeIds: string[]; turnKeys: Set<string> } {
  const nodeIds: string[] = [];
  const turnKeys = new Set<string>();
  for (const n of nodes) {
    const tk = (n.data as any)?.turnKey;
    if (tk != null && tk === anchorTurnKey) { nodeIds.push(n.id); turnKeys.add(tk); }
  }
  return { nodeIds, turnKeys };
}
